import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/sustainable-plastics/chem.jpg")